/* Spanish catalog mirroring locale-advisor-costs-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'adv.cost.review': 'Revisar',
  'adv.cost.moreTitle': 'Más oportunidades',
  'adv.cost.observedValue': 'Valor observado',
  'adv.cost.invoiceBasis': 'Base de facturación',
  'adv.cost.draftValue': 'Valor en borradores',
  'adv.cost.possibleCount': 'Posibles duplicados',
  'adv.cost.purchaseShare': 'Peso en las compras',
  'adv.cost.givenDiscount': 'Descuento concedido',
  'adv.cost.unbilledNote': 'Base de facturación, no ingresos contabilizados',
  'adv.cost.draftNote': 'Valor en borradores, no ingresos contabilizados',
  'adv.cost.acceptedNote': 'Presupuestos aceptados sin factura vinculada',
  'adv.cost.duplicateNote': 'Posibles duplicados por revisar',
  'adv.cost.supplierNote': 'Volumen de compras que podría respaldar una negociación',
  'adv.cost.discountTitle': 'Revisar los descuentos concedidos',
  'adv.cost.discountNote': 'Descuentos realmente concedidos, no ahorros estimados',
  'adv.cost.voucherNote': 'Documentación pendiente de seguimiento; sin ahorro estimado',
  'adv.cost.followUp': 'Por hacer seguimiento',
  'adv.cost.increaseToReview': 'Aumento por revisar',
  'adv.cost.fixedTitle': 'Costes fijos contabilizados',
  'adv.cost.tryAdjustment': 'Probar un ajuste',
  'adv.cost.fixedDetail': 'Promedio mensual basado en {months} meses completos',
  'adv.cost.otherTitle': 'Mayores cuentas de otros costes',
  'adv.cost.otherIntro': 'El porcentaje compara el coste contabilizado con los ingresos del año seleccionado. No es un ahorro estimado, y la cuenta no se clasifica automáticamente como variable.',
  'adv.cost.otherDetail': '{amount} contabilizados en el año seleccionado',
  'adv.cost.ofRevenue': 'de los ingresos',
  'adv.cost.noRevenueShare': 'Porcentaje no calculado',
  'adv.cost.sub': 'Mayores cuentas de costes contabilizados y variación respecto al año anterior',
  'adv.cost.subPeriod': 'Mayores cuentas de costes contabilizados y variación respecto al mismo período del año anterior',
  'adv.cost.help': 'Las cuentas proceden de la cuenta de resultados del año seleccionado. Las barras muestran el importe contabilizado por cuenta. La variación solo se muestra cuando la misma cuenta tenía un importe positivo el año anterior.',
  'adv.cost.helpPeriod': 'Las cuentas proceden de la cuenta de resultados hasta el mes actual. Las barras muestran el importe contabilizado por cuenta. La variación se compara con el mismo período del año anterior cuando la cuenta tenía un importe positivo.',
  'adv.cost.rowHelp': 'Contabilizado en esta cuenta: {amount} en el año seleccionado. Variación respecto al año anterior: {change}.',
  'adv.cost.noComparison': 'Sin cifra del año anterior',
  'adv.cost.emptyText': 'No hay cuentas de costes contabilizados en el año seleccionado.',
  'adv.cost.flagText': '{name} ha aumentado considerablemente respecto al año anterior. Comprueba si el cambio estaba previsto y revisa los asientos de esta cuenta.',
  'adv.why.costSub': 'Cuentas de costes que han aumentado considerablemente respecto al año anterior',
});
